module.exports = __webpack_public_path__ + "img/right-girl1.ad0c23f4.svg";